/**
 * Enums de domínio compartilhados entre API e Web.
 *
 * IMPORTANTE: estes valores espelham os enums do schema Prisma
 * (apps/api/prisma/schema.prisma). Ao alterar um, altere o outro.
 * A API tem um teste que falha se os dois divergirem.
 *
 * Usamos objetos "as const" em vez de `enum` do TypeScript porque:
 *  - funcionam igual em CommonJS e ESM (o front é ESM, a API é CommonJS);
 *  - geram tipos união literais, que combinam com o que o Prisma gera.
 */

export const Role = {
  ADMIN: 'ADMIN',
  GESTOR: 'GESTOR',
  VENDEDOR: 'VENDEDOR',
} as const;
export type Role = (typeof Role)[keyof typeof Role];

export const SaleStatus = {
  /** Importada do Conta Azul, aguardando o vendedor informar os custos. */
  AGUARDANDO_CUSTO: 'AGUARDANDO_CUSTO',
  /** Custos informados; lucro e comissão calculados. */
  CUSTO_INFORMADO: 'CUSTO_INFORMADO',
  /** Cancelada no Conta Azul. Antes do fechamento, sai do cálculo. */
  CANCELADA: 'CANCELADA',
  /** Excluída no Conta Azul. Sai dos painéis e do cálculo; fica só no histórico. */
  EXCLUIDA: 'EXCLUIDA',
} as const;
export type SaleStatus = (typeof SaleStatus)[keyof typeof SaleStatus];

export const ClosingStatus = {
  ABERTO: 'ABERTO',
  FECHADO: 'FECHADO',
} as const;
export type ClosingStatus = (typeof ClosingStatus)[keyof typeof ClosingStatus];

export const AlertType = {
  /** Margem acima do limite configurado (possível custo subdeclarado). */
  MARGEM_ALTA: 'MARGEM_ALTA',
  /** Custo informado igual a zero. */
  CUSTO_ZERO: 'CUSTO_ZERO',
  /** Custo maior que o valor da venda; comissão fica em R$ 0. */
  PREJUIZO: 'PREJUIZO',
  /** Custo alterado depois de já ter sido informado. */
  CUSTO_ALTERADO: 'CUSTO_ALTERADO',
} as const;
export type AlertType = (typeof AlertType)[keyof typeof AlertType];

export const SyncStatus = {
  EM_ANDAMENTO: 'EM_ANDAMENTO',
  SUCESSO: 'SUCESSO',
  FALHA: 'FALHA',
} as const;
export type SyncStatus = (typeof SyncStatus)[keyof typeof SyncStatus];

export const IntegrationProvider = {
  CONTA_AZUL: 'CONTA_AZUL',
} as const;
export type IntegrationProvider = (typeof IntegrationProvider)[keyof typeof IntegrationProvider];

/** Rótulos em português para exibição na interface. */
export const ROLE_LABELS: Record<Role, string> = {
  ADMIN: 'Administrador',
  GESTOR: 'Gestor',
  VENDEDOR: 'Vendedor',
};

export const SALE_STATUS_LABELS: Record<SaleStatus, string> = {
  AGUARDANDO_CUSTO: 'Aguardando custo',
  CUSTO_INFORMADO: 'Custo informado',
  CANCELADA: 'Cancelada',
  EXCLUIDA: 'Excluída no Conta Azul',
};
